// import { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Box, Typography, Snackbar, Alert, Grid, CircularProgress, Paper, TextField, InputLabel, MenuItem, FormControl, Select, Button as MuiButton, Stack, Chip, Dialog, DialogTitle, DialogContent, IconButton, } from '@mui/material';
// import AttachmentIcon from '@mui/icons-material/Attachment';
// import CloseIcon from '@mui/icons-material/Close';
// import Dropdown from '../components/Dropdown';
// import { useAuth } from '../context/AuthContext';
// import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
// import dayjs from 'dayjs';

// const formatDateTimeForInput = (dateStr) => {
//     if (!dateStr) return '';
//     const d = new Date(dateStr);
//     if (isNaN(d.getTime())) return '';
//     const pad = (n) => String(n).padStart(2, '0');
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
// };

// // helper to detect image attachments (existing from backend)
// const isImageAttachment = (att) => {
//     if (!att) return false;
//     if (att.mimeType && typeof att.mimeType === 'string') {
//         return att.mimeType.toLowerCase().startsWith('image/');
//     }
//     const name = att.fileName || att.name || '';
//     return /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(name);
// };

// function TaskForm({ connectionString }) {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const path = connectionString;
//     const { user, selectedCompany } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;
//     const uId = user?.UserId || null;
//     const userName = user?.EmployeeName || 'Unknown User';
//     const taskData = location.state?.taskData || null;
//     const overallMode = location.state?.mode || (taskData ? 'edit' : 'insert');
//     const [title, setTitle] = useState('');
//     const [description, setDescription] = useState('');
//     const [assignedToId, setAssignedToId] = useState('');
//     const [assignedToName, setAssignedToName] = useState('');
//     const [dueDateTime, setDueDateTime] = useState('');
//     const [priority, setPriority] = useState('Medium');
//     const [status, setStatus] = useState('Pending');
//     const [reminderMinutesBefore, setReminderMinutesBefore] = useState(60);
//     const [usersOptions, setUsersOptions] = useState([]);
//     const [formErrors, setFormErrors] = useState([]);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [serverAttachmentIds, setServerAttachmentIds] = useState([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
//     // raw File objects (for FormData)
//     const [files, setFiles] = useState([]);
//     // previews for new uploads → store base64 here
//     const [filePreviews, setFilePreviews] = useState([]);
//     // existing attachments from DB, normalized
//     const [existingAttachments, setExistingAttachments] = useState([]);
//     // Image viewer dialog state (always fed with base64)
//     const [imageViewer, setImageViewer] = useState({ open: false, src: '', title: '', });

//     useEffect(() => {
//         console.log('TaskForm mode:', overallMode);
//         console.log('TaskForm initial taskData:', taskData);
//     }, [overallMode, taskData]);

//     useEffect(() => {
//         axios.get(`${path}/api/users`, { params: { companyId } })
//             .then((res) => {
//                 const fetchedUsers = Array.isArray(res.data.data) ? res.data.data : [];
//                 setUsersOptions(fetchedUsers);

//                 if (overallMode === 'insert' && uId) {
//                     const selfUser = fetchedUsers.find((u) => String(u.UserId) === String(uId));
//                     if (selfUser) {
//                         setAssignedToId(String(selfUser.UserId));
//                         setAssignedToName(selfUser.employeeName);
//                     } else {
//                         setAssignedToId(String(uId));
//                         setAssignedToName(userName);
//                     }
//                 }
//             })
//             .catch((error) => console.error('Error fetching users:', error));
//     }, [companyId, overallMode, path, uId, userName]);

//     // ⬇️ UPDATED useEffect: still sets all fields + now uses separate attachments API (without removing old logic)
//     useEffect(() => {
//         // if (!taskData) return;
//         if (!taskData?.TaskId) return;

//         // existing logic: set basic fields
//         setTitle(taskData.TaskTitle || '');
//         setDescription(taskData.Description || '');
//         setAssignedToId(String(taskData.AssignedToId || ''));
//         setAssignedToName(taskData.AssignedToName || '');
//         setDueDateTime(formatDateTimeForInput(taskData.DueDateTime));
//         setPriority(taskData.Priority || 'Medium');
//         setStatus(taskData.Status || 'Pending');
//         setReminderMinutesBefore(taskData.ReminderMinutesBefore || 60);

//         const fetchAttachments = async () => {
//             try {
//                 // ✅ NEW: separate API to get attachments in base64 (like your product/fetch-images example)
//                 if (taskData.TaskId) {
//                     const attRes = await axios.get(`${path}/api/tasks/fetch-attachments?taskId=${taskData.TaskId}&companyId=${companyId}`);

//                     console.log('Separate attachment API response:', attRes.data);

//                     // Assuming API returns an array: [{ mimeType, image, fileName, id, sequence }, ...]
//                     if (Array.isArray(attRes.data) && attRes.data.length > 0) {
//                         const previews = attRes.data.map((img) => ({
//                             // base64 data URL (exactly like your product images code)
//                             url: img.image
//                                 ? `data:${img.mimeType};base64,${img.image}`
//                                 : img.fileUrl
//                                     ? `${path}/${img.fileUrl.replace(/^\/+/, '')}`
//                                     : '',
//                             // Ensure image exists
//                             fileName: img.fileName,
//                             id: img.id,
//                             sequence: img.sequence,
//                             isNew: false,
//                             mimeType: img.mimeType,
//                             // keep original fields too, in case you use them somewhere else later
//                             ...img,
//                         }));

//                         setExistingAttachments(previews);
//                         setServerAttachmentIds(previews.map(p => p.id));
//                         return; // ⬅️ don't fall back if dedicated API succeeded
//                     }
//                 }

//                 // ⬇️ existing logic (fallback): use taskData.Attachments if separate API is empty
//                 const rawAttachments = Array.isArray(taskData.Attachments) ? taskData.Attachments : [];

//                 const normalized = rawAttachments.map((att) => {
//                     let url = att.url || '';

//                     // Case 1: backend already provides base64 + mimeType (similar to ProductMaster)
//                     if (!url && att.image && att.mimeType) {
//                         url = `data:${att.mimeType};base64,${att.image}`;
//                     }

//                     // Case 2: backend sends filePath relative to server
//                     if (!url && att.filePath) {
//                         const cleanPath = att.filePath.startsWith('/') ? att.filePath.substring(1) : att.filePath;
//                         url = `${path}/${cleanPath}`;
//                     }

//                     return { ...att, url, };
//                 });

//                 console.log('Fallback raw attachments from taskData:', rawAttachments);
//                 console.log('Fallback normalized attachments:', normalized);

//                 setExistingAttachments(normalized);
//                 setServerAttachmentIds(
//                     normalized
//                         .filter(a => a.id)
//                         .map(a => a.id)
//                 );
//             } catch (err) {
//                 console.error('Error fetching attachments (API or fallback):', err);

//                 // On any error, still try to use existing taskData.Attachments
//                 const rawAttachments = Array.isArray(taskData.Attachments) ? taskData.Attachments : [];

//                 const normalized = rawAttachments.map((att) => {
//                     let url = att.url || '';

//                     if (!url && att.image && att.mimeType) {
//                         url = `data:${att.mimeType};base64,${att.image}`;
//                     }

//                     if (!url && att.filePath) {
//                         const cleanPath = att.filePath.startsWith('/') ? att.filePath.substring(1) : att.filePath;
//                         url = `${path}/${cleanPath}`;
//                     }

//                     return { ...att, url, };
//                 });

//                 setExistingAttachments(normalized);
//                 setServerAttachmentIds(
//                     normalized
//                         .filter(a => a.id)
//                         .map(a => a.id)
//                 );
//             }
//         };

//         fetchAttachments();
//     }, [taskData, path]);

//     // Function to open the image viewer dialog
//     const openImageViewer = (src, title) => {
//         setImageViewer({ open: true, src: src, title: title || 'Attachment', });
//     };

//     // Dialog to display the image in full size
//     const ImageViewerDialog = () => (
//         <Dialog open={imageViewer.open} onClose={() => setImageViewer((v) => ({ ...v, open: false }))} maxWidth="md" fullWidth>
//             <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                 <span>{imageViewer.title}</span>
//                 <IconButton onClick={() => setImageViewer((v) => ({ ...v, open: false }))} size="small">
//                     {/* <CloseIcon
//                         sx={{ cursor: 'pointer', color: 'red', ml: 0.5 }}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setExistingAttachments(prev =>
//                                 prev.filter((_, i) => i !== idx)
//                             );
//                         }}
//                     /> */}
//                 </IconButton>
//             </DialogTitle>
//             <DialogContent dividers>
//                 {imageViewer.src && (
//                     <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//                         <img src={imageViewer.src} alt={imageViewer.title || 'Attachment'} style={{ maxWidth: '100%', maxHeight: '80vh' }} />
//                     </Box>
//                 )}
//             </DialogContent>
//         </Dialog>
//     );

//     const handleAssignChange = (selected) => {
//         setAssignedToId(String(selected.UserId));
//         setAssignedToName(selected.employeeName);
//     };

//     // Read selected files as base64 for previews (FormData logic unchanged)
//     const handleFileChange = (e) => {
//         const fileList = Array.from(e.target.files || []);
//         setFiles(fileList);
//         setFilePreviews([]); // reset previews

//         fileList.forEach((file) => {
//             const isImg = file.type && file.type.toLowerCase().startsWith('image/');

//             if (!isImg) {
//                 // non-image: no need base64, just show as chip
//                 setFilePreviews((prev) => [...prev, { file, url: '', isImage: false, },]);
//                 return;
//             }

//             const reader = new FileReader();
//             reader.onload = () => {
//                 // reader.result is base64 data URL
//                 setFilePreviews((prev) => [...prev, { file, url: reader.result, isImage: true, },]);
//             };
//             reader.readAsDataURL(file);
//         });
//     };

//     // Function for form submission
//     const handleSubmit = useCallback(
//         async (e) => {
//             e.preventDefault();
//             const errors = [];

//             if (!title.trim()) errors.push('Title is mandatory.');
//             if (!assignedToId) errors.push('Assigned To is mandatory.');
//             if (!dueDateTime) errors.push('Due date & time is mandatory.');

//             const due = new Date(dueDateTime);
//             if (isNaN(due.getTime())) {
//                 errors.push('Invalid due date & time.');
//             }

//             if (errors.length > 0) {
//                 setFormErrors(errors);
//                 return;
//             }

//             setIsSubmitting(true);
//             setFormErrors([]);

//             try {
//                 const formData = new FormData();
//                 formData.append('taskTitle', title);
//                 formData.append('description', description);
//                 formData.append('assignedToId', assignedToId);
//                 formData.append('assignedToName', assignedToName);
//                 formData.append('assignedById', String(uId));
//                 formData.append('assignedByName', userName);
//                 formData.append('companyId', companyId);
//                 formData.append('dueDateTime', dueDateTime);
//                 formData.append('priority', priority);
//                 formData.append('status', status);
//                 formData.append('reminderMinutesBefore', reminderMinutesBefore);

//                 // ⬇️ NO CHANGE: still send binary files through FormData
//                 files.forEach((f) => { formData.append('files', f); });

//                 const debugPayload = { mode: overallMode, taskId: overallMode === 'edit' ? taskData?.TaskId : null, taskTitle: title, description, assignedToId, assignedToName, assignedById: String(uId), assignedByName: userName, companyId, dueDateTime, priority, status, reminderMinutesBefore, files: files.map((f) => f.name), };
//                 console.log('TaskForm submit mode:', overallMode);
//                 console.log('TaskForm submit payload:', debugPayload);
//                 console.log(formData);
//                 let res;

//                 if (overallMode === 'edit') {

//                     // IDs currently visible in UI (user kept)
//                     const currentIds = existingAttachments
//                         .filter(a => a.id && !a.isNew)
//                         .map(a => a.id);

//                     // IDs originally on server but now missing (user removed)
//                     const deletedAttachmentIds = serverAttachmentIds
//                         .filter(id => !currentIds.includes(id));

//                     // send to backend
//                     formData.append(
//                         'deleteAttachmentIds',
//                         JSON.stringify(deletedAttachmentIds)
//                     );
//                 }

//                 if (overallMode === 'edit' && taskData?.TaskId) {
//                     formData.append('taskId', taskData.TaskId);
//                     res = await axios.put(`${path}/api/tasks/${taskData.TaskId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
//                 } else {
//                     res = await axios.post(`${path}/api/tasks`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
//                 }

//                 if (res.status === 200 || res.status === 201) {
//                     setSnackbar({ open: true, message: overallMode === 'edit' ? 'Task updated successfully!' : 'Task created successfully!', severity: 'success', });
//                     navigate(-1);
//                 } else {
//                     setSnackbar({ open: true, message: res.data?.message || 'Task save failed.', severity: 'error', });
//                 }
//             } catch (err) {
//                 console.error('Error saving task:', err);
//                 setSnackbar({ open: true, message: 'Something went wrong while saving the task.', severity: 'error', });
//             } finally {
//                 setIsSubmitting(false);
//             }
//         },
//         [assignedToId, assignedToName, companyId, dueDateTime, overallMode, path, priority, reminderMinutesBefore, status, taskData, title, description, files, uId, userName, navigate,]
//     );

//     const handleCancel = () => navigate(-1);

//     return (
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
//             <Paper sx={{ p: 3, maxWidth: 900, width: '100%' }}>
//                 <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', mb: 3, textDecoration: 'underline', textUnderlineOffset: 8 }} >
//                     {overallMode === 'edit' ? 'Edit Task' : 'Create New Task'}
//                 </Typography>

//                 <Box display="flex" flexWrap="wrap" gap={2}>
//                     {/* LEFT COLUMN – title, description, attachments */}
//                     <Box
//                         sx={{
//                             flex: { xs: "100%", md: "48%" },
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: 2
//                         }}
//                     >
//                         <TextField label="Task Title" value={title} onChange={(e) => setTitle(e.target.value)} fullWidth required sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} />
//                         <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline minRows={2.7} />

//                         {/* Attachments under description */}
//                         <Box>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                 Attachments (images, videos, audio, documents, etc.)
//                             </Typography>
//                             <input type="file" multiple onChange={handleFileChange} />

//                             {/* New uploads (base64 previews) */}
//                             {filePreviews.length > 0 && (
//                                 <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap">
//                                     {filePreviews.map((p, index) =>
//                                         p.isImage ? (
//                                             <Box key={index} onClick={() => openImageViewer(p.url, p.file.name)}
//                                                 sx={{ width: 80, height: 80, borderRadius: 1, overflow: 'hidden', border: '1px solid #ccc', mr: 1, mb: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fafafa', }}
//                                             >
//                                                 <img src={p.url} alt={p.file.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                                             </Box>
//                                         ) : (
//                                             <Chip key={index} icon={<AttachmentIcon />} label={p.file.name} sx={{ mb: 1 }} variant="outlined" />
//                                         )
//                                     )}
//                                 </Stack>
//                             )}

//                             {/* Existing attachments (edit mode) */}
//                             {existingAttachments.length > 0 && (
//                                 <>
//                                     <Typography variant="subtitle2" sx={{ mt: 2 }}>
//                                         Existing Attachments:
//                                     </Typography>
//                                     <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap">
//                                         {existingAttachments.map((att, idx) => {
//                                             const isImg = isImageAttachment(att);
//                                             const src = att.url;
//                                             const label = att.fileName || att.name || `Attachment ${idx + 1}`;

//                                             if (isImg && src) {
//                                                 return (
//                                                     <Box
//                                                         key={idx}
//                                                         sx={{
//                                                             position: 'relative',
//                                                             width: 80,
//                                                             height: 80,
//                                                             borderRadius: 1,
//                                                             overflow: 'hidden',
//                                                             border: '1px solid #ccc',
//                                                             mr: 1,
//                                                             mb: 1,
//                                                             cursor: 'pointer',
//                                                             backgroundColor: '#fafafa',
//                                                         }}
//                                                     >
//                                                         <img
//                                                             src={src}
//                                                             alt={label}
//                                                             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                                                             onClick={() => openImageViewer(src, label)}
//                                                         />

//                                                         {/* ❌ REMOVE BUTTON */}
//                                                         <IconButton
//                                                             size="small"
//                                                             sx={{
//                                                                 position: 'absolute',
//                                                                 top: 2,
//                                                                 right: 2,
//                                                                 bgcolor: 'rgba(0,0,0,0.6)',
//                                                                 color: '#fff',
//                                                                 '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' },
//                                                             }}
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 setExistingAttachments(prev =>
//                                                                     prev.filter((_, i) => i !== idx)
//                                                                 );
//                                                             }}
//                                                         >
//                                                             <CloseIcon fontSize="small" />
//                                                         </IconButton>
//                                                     </Box>
//                                                 );
//                                             }

//                                             return (
//                                                 <Chip
//                                                     key={idx}
//                                                     icon={<AttachmentIcon />}
//                                                     label={label}
//                                                     variant="outlined"
//                                                     onDelete={() =>
//                                                         setExistingAttachments(prev =>
//                                                             prev.filter((_, i) => i !== idx)
//                                                         )
//                                                     }
//                                                     onClick={() => {
//                                                         if (att.url) {
//                                                             window.open(att.url, '_blank', 'noopener,noreferrer');
//                                                         }
//                                                     }}
//                                                 />

//                                             );
//                                         })}
//                                     </Stack>
//                                 </>
//                             )}
//                         </Box>
//                     </Box>

//                     {/* RIGHT COLUMN – assign / due / priority / status / reminder */}
//                     <Box
//                         sx={{
//                             flex: { xs: "100%", md: "48%" },
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: 2
//                         }}
//                     >
//                         <Dropdown id="assignTo" label="Assign To" valueKey="UserId" labelKey="employeeName" value={assignedToId} options={usersOptions} onChange={handleAssignChange} fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} />


//                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                             <DesktopDateTimePicker
//                                 label="Due Date & Time"
//                                 value={dueDateTime ? dayjs(dueDateTime) : null}
//                                 onChange={(newValue) => {
//                                     if (newValue && newValue.isValid()) {
//                                         setDueDateTime(newValue.format('YYYY-MM-DDTHH:mm'));
//                                     } else {
//                                         setDueDateTime('');
//                                     }
//                                 }}
//                                 viewRenderers={{
//                                     hours: renderTimeViewClock,
//                                     minutes: renderTimeViewClock,
//                                 }}
//                                 ampm={false}
//                                 format="DD MMMM YYYY • HH:mm"  // More elegant display (e.g., "16 December 2025 • 14:30")
//                                 timeSteps={{ hours: 1, minutes: 5, seconds: 1 }}
//                                 slotProps={{
//                                     textField: {
//                                         fullWidth: true,
//                                         required: true,
//                                         variant: "outlined",
//                                         sx: {
//                                             '& .MuiOutlinedInput-root': {
//                                                 borderRadius: 2,
//                                                 fontWeight: 500,
//                                                 height: 38,
//                                                 backgroundColor: 'background.paper',
//                                                 transition: 'all 0.3s ease',
//                                                 '&:hover': {
//                                                     boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
//                                                 },
//                                                 '&.Mui-focused': {
//                                                     boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
//                                                 },
//                                             },
//                                             '& .MuiInputLabel-root.Mui-focused': {
//                                                 color: 'primary.main',
//                                                 fontWeight: 600,
//                                             },
//                                         },
//                                     },
//                                     popper: {
//                                         sx: {
//                                             '& .MuiPickersPopper-paper': {
//                                                 borderRadius: 4,
//                                                 boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
//                                                 overflow: 'hidden',
//                                                 mt: 1,
//                                             },
//                                             '& .MuiPickersLayout-root': {
//                                                 borderRadius: 4,
//                                             },
//                                             '& .MuiPickersDay-root': {
//                                                 borderRadius: '12px',
//                                                 fontWeight: 500,
//                                                 transition: 'all 0.2s ease',
//                                                 '&:hover': {
//                                                     backgroundColor: 'primary.main',
//                                                     color: 'primary.contrastText',
//                                                 },
//                                             },
//                                             '& .MuiPickersDay-today': {
//                                                 border: '2px solid',
//                                                 borderColor: 'primary.main',
//                                                 backgroundColor: 'transparent',
//                                                 fontWeight: 700,
//                                             },
//                                             '& .MuiPickersDay-selected': {
//                                                 backgroundColor: 'primary.main',
//                                                 color: 'primary.contrastText',
//                                                 fontWeight: 600,
//                                                 '&:hover': {
//                                                     backgroundColor: 'primary.dark',
//                                                 },
//                                             },
//                                             '& .MuiClock-clock': {
//                                                 backgroundColor: 'grey.50',
//                                                 boxShadow: 'inset 0 4px 12px rgba(0,0,0,0.05)',
//                                             },
//                                             '& .MuiClock-pin': {
//                                                 backgroundColor: 'primary.main',
//                                                 width: 4,
//                                             },
//                                             '& .MuiClockPointer-pointer': {
//                                                 backgroundColor: 'primary.main',
//                                             },
//                                             '& .MuiClockPointer-thumb': {
//                                                 border: '6px solid',
//                                                 borderColor: 'primary.main',
//                                                 backgroundColor: 'common.white',
//                                                 boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//                                             },
//                                             '& .MuiClockNumber-root.Mui-selected': {
//                                                 backgroundColor: 'primary.main',
//                                                 color: 'primary.contrastText',
//                                                 fontWeight: 600,
//                                             },
//                                         },
//                                     },
//                                     actionBar: {
//                                         actions: ['clear', 'cancel', 'accept'],
//                                     },
//                                 }}
//                             />
//                         </LocalizationProvider>

//                         <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}>
//                             <InputLabel id="priority-label">Priority</InputLabel>
//                             <Select labelId="priority-label" label="Priority" value={priority} onChange={(e) => setPriority(e.target.value)} >
//                                 <MenuItem value="Low">Low</MenuItem>
//                                 <MenuItem value="Medium">Medium</MenuItem>
//                                 <MenuItem value="High">High</MenuItem>
//                             </Select>
//                         </FormControl>

//                         <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}>
//                             <InputLabel id="status-label">Status</InputLabel>
//                             <Select labelId="status-label" label="Status" value={status} onChange={(e) => setStatus(e.target.value)}  >
//                                 <MenuItem value="Pending">Pending</MenuItem>
//                                 <MenuItem value="In Progress">In Progress</MenuItem>
//                                 <MenuItem value="Completed">Completed</MenuItem>
//                                 <MenuItem value="Cancelled">Cancelled</MenuItem>
//                             </Select>
//                         </FormControl>

//                         <TextField label="Reminder (minutes before)" type="number" value={reminderMinutesBefore} onChange={(e) => setReminderMinutesBefore(Number(e.target.value) || 0)} fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} helperText="Default is 60 (1 hour before)" />
//                     </Box>
//                 </Box>

//                 {/* Errors */}
//                 {formErrors.length > 0 && (
//                     <Box sx={{ mx: 'auto', maxWidth: 400, p: 2, bgcolor: '#ffebee', border: 1, borderColor: '#f44336', borderRadius: 1, color: '#b71c1c', mt: 3, }} >
//                         <Typography fontWeight="bold">Please fix:</Typography>
//                         <ul>
//                             {formErrors.map((e, i) => (
//                                 <li key={i}>{e}</li>
//                             ))}
//                         </ul>
//                     </Box>
//                 )}

//                 {/* Action buttons */}
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 3, justifyContent: 'center', }} >
//                     <MuiButton onClick={handleSubmit} variant="contained" color="primary" sx={{ minWidth: 120, height: 40 }} disabled={isSubmitting} >
//                         {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
//                     </MuiButton>
//                     <MuiButton onClick={handleCancel} variant="contained" color="error" sx={{ minWidth: 120, height: 40 }} disabled={isSubmitting} >
//                         Cancel
//                     </MuiButton>
//                 </Box>
//             </Paper>

//             {/* Image Viewer Dialog → always show base64 or URL */}
//             <ImageViewerDialog />

//             <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} >
//                 <Alert onClose={() => setSnackbar((s) => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }

// export default TaskForm;





import { colors as themeColors } from '../utils/theme';
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Snackbar, Alert, Grid, CircularProgress, Paper, TextField, InputLabel, MenuItem, FormControl, Select, Button as MuiButton, Stack, Chip, Dialog, DialogTitle, DialogContent, IconButton, } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CloseIcon from '@mui/icons-material/Close';
import Dropdown from '../components/Dropdown';
import { useAuth } from '../context/AuthContext';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';

const formatDateTimeForInput = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// helper to detect image attachments (existing from backend)
const isImageAttachment = (att) => {
    if (!att) return false;
    if (att.mimeType && typeof att.mimeType === 'string') {
        return att.mimeType.toLowerCase().startsWith('image/');
    }
    const name = att.fileName || att.name || '';
    return /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(name);
};

function TaskForm({ connectionString }) {
    const navigate = useNavigate();
    const location = useLocation();
    const path = connectionString;
    const { user, selectedCompany } = useAuth();
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory;
    const uId = user?.UserId || null;
    const userName = user?.EmployeeName || 'Unknown User';
    const taskData = location.state?.taskData || null;
    const overallMode = location.state?.mode || (taskData ? 'edit' : 'insert');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [assignedToId, setAssignedToId] = useState('');
    const [assignedToName, setAssignedToName] = useState('');
    const [dueDateTime, setDueDateTime] = useState('');
    const [priority, setPriority] = useState('Medium');
    const [status, setStatus] = useState('Pending');
    const [reminderMinutesBefore, setReminderMinutesBefore] = useState(60);
    const [usersOptions, setUsersOptions] = useState([]);
    const [formErrors, setFormErrors] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [serverAttachmentIds, setServerAttachmentIds] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
    // raw File objects (for FormData)
    const [files, setFiles] = useState([]);
    // previews for new uploads → store base64 here
    const [filePreviews, setFilePreviews] = useState([]);
    // existing attachments from DB, normalized
    const [existingAttachments, setExistingAttachments] = useState([]);
    // Image viewer dialog state (always fed with base64)
    const [imageViewer, setImageViewer] = useState({ open: false, src: '', title: '', });

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    useEffect(() => {
        console.log('TaskForm mode:', overallMode);
        console.log('TaskForm initial taskData:', taskData);
    }, [overallMode, taskData]);

    useEffect(() => {
        axios.get(`${path}/api/users`, { params: { companyId } })
            .then((res) => {
                const fetchedUsers = Array.isArray(res.data.data) ? res.data.data : [];
                setUsersOptions(fetchedUsers);

                if (overallMode === 'insert' && uId) {
                    const selfUser = fetchedUsers.find((u) => String(u.UserId) === String(uId));
                    if (selfUser) {
                        setAssignedToId(String(selfUser.UserId));
                        setAssignedToName(selfUser.employeeName);
                    } else {
                        setAssignedToId(String(uId));
                        setAssignedToName(userName);
                    }
                }
            })
            .catch((error) => console.error('Error fetching users:', error));
    }, [companyId, overallMode, path, uId, userName]);

    // ⬇️ UPDATED useEffect: still sets all fields + now uses separate attachments API (without removing old logic)
    useEffect(() => {
        // if (!taskData) return;
        console.log(taskData)
        if (!taskData?.TaskId) return;

        // existing logic: set basic fields
        setTitle(taskData.TaskTitle || '');
        setDescription(taskData.Description || '');
        setAssignedToId(String(taskData.AssignedToId || ''));
        setAssignedToName(taskData.AssignedToName || '');
        setDueDateTime(formatDateTimeForInput(taskData.DueDateTime));
        setPriority(taskData.Priority || 'Medium');
        setStatus(taskData.Status || 'Pending');
        setReminderMinutesBefore(taskData.ReminderMinutesBefore || 60);

        // const fetchAttachments = async () => {
        //     try {
        //         // ✅ NEW: separate API to get attachments in base64 (like your product/fetch-images example)
        //         if (taskData.TaskId) {
        //             const attRes = await axios.get(`${path}/api/tasks/fetch-attachments?taskId=${taskData.TaskId}&companyId=${companyId}`);

        //             console.log('Separate attachment API response:', attRes.data);

        //             // Assuming API returns an array: [{ mimeType, image, fileName, id, sequence }, ...]
        //             if (Array.isArray(attRes.data) && attRes.data.length > 0) {
        //                 const normalized = attRes.data.map((att) => {
        //                     const isImage = att.mimeType?.startsWith('image/');
        //                     const hasBase64 = Boolean(att.image);
        //                     const hasFileUrl = Boolean(att.fileUrl);

        //                     let url = '';

        //                     // ✅ IMAGE → base64 preview
        //                     if (isImage && hasBase64) {
        //                         url = `data:${att.mimeType};base64,${att.image}`;
        //                     }
        //                     // ✅ PDF / OTHER → server URL
        //                     else if (hasFileUrl) {
        //                         url = `${path}/${att.fileUrl.replace(/^\/+/, '')}`;
        //                     }

        //                     return {
        //                         id: att.id,
        //                         fileName: att.fileName,
        //                         mimeType: att.mimeType,
        //                         fileSize: att.fileSize,

        //                         url, // 👈 SINGLE source of truth
        //                         isPreviewAvailable: isImage,

        //                         isNew: false,
        //                         ...att
        //                     };
        //                 });

        //                 setExistingAttachments(normalized);
        //                 setServerAttachmentIds(normalized.map(a => a.id));
        //             }
        //         }

        //         // ⬇️ existing logic (fallback): use taskData.Attachments if separate API is empty
        //         const rawAttachments = Array.isArray(taskData.Attachments) ? taskData.Attachments : [];

        //         const fallbackNormalized = rawAttachments.map((att) => {
        //             const isImage = att.mimeType?.startsWith('image/');
        //             let url = att.url || '';

        //             if (!url && isImage && att.image && att.mimeType) {
        //                 url = `data:${att.mimeType};base64,${att.image}`;
        //             }

        //             if (!url && att.filePath) {
        //                 const cleanPath = att.filePath.replace(/^\/+/, '');
        //                 url = `${path}/${cleanPath}`;
        //             }

        //             return {
        //                 ...att,
        //                 url,
        //                 isPreviewAvailable: isImage
        //             };
        //         });

        //         console.log('Fallback raw attachments from taskData:', rawAttachments);
        //         console.log('Fallback normalized attachments:', fallbackNormalized);

        //         setExistingAttachments(fallbackNormalized);
        //         setServerAttachmentIds( fallbackNormalized.filter(a => a.id).map(a => a.id) );
        //     } catch (err) {
        //         console.error('Error fetching attachments (API or fallback):', err);

        //         // On any error, still try to use existing taskData.Attachments
        //         const rawAttachments = Array.isArray(taskData.Attachments) ? taskData.Attachments : [];
        //         // console.l

        //         const normalized = rawAttachments.map((att) => {
        //             let url = att.url || '';

        //             if (!url && att.image && att.mimeType) {
        //                 url = `data:${att.mimeType};base64,${att.image}`;
        //             }

        //             if (!url && att.filePath) {
        //                 const cleanPath = att.filePath.startsWith('/') ? att.filePath.substring(1) : att.filePath;
        //                 url = `${path}/${cleanPath}`;
        //             }

        //             return { ...att, url, };
        //         });

        //         setExistingAttachments(normalized);
        //         setServerAttachmentIds( normalized.filter(a => a.id).map(a => a.id) );
        //     }
        // };

        const fetchAttachments = async () => {
            try {
                if (!taskData?.TaskId) return;

                const attRes = await axios.get(
                    `${path}/api/tasks/fetch-attachments`,
                    { params: { taskId: taskData.TaskId, companyId } }
                );

                console.log('Attachment API response:', attRes.data);

                if (Array.isArray(attRes.data) && attRes.data.length > 0) {
                    const normalized = attRes.data.map((att) => {
                        const isImage = att.mimeType?.startsWith('image/');
                        let url = '';

                        if (isImage && att.image) {
                            // ✅ IMAGE BASE64
                            url = `data:${att.mimeType};base64,${att.image}`;
                        } else if (att.fileUrl) {
                            // ✅ PDF / OTHER FILE
                            url = `${path}/${att.fileUrl.replace(/^\/+/, '')}`;
                        }

                        return {
                            id: att.id,
                            fileName: att.fileName,
                            mimeType: att.mimeType,
                            fileSize: att.fileSize,
                            url,
                            isPreviewAvailable: isImage,
                            isNew: false
                        };
                    });

                    setExistingAttachments(normalized);
                    setServerAttachmentIds(normalized.map(a => a.id));
                    return; // 🔥🔥🔥 STOP HERE — DO NOT FALLBACK
                }

                // ---- FALLBACK ONLY IF API RETURNS EMPTY ----
                const rawAttachments = Array.isArray(taskData.Attachments)
                    ? taskData.Attachments
                    : [];

                const fallback = rawAttachments.map((att) => {
                    let url = '';

                    if (att.image && att.mimeType) {
                        url = `data:${att.mimeType};base64,${att.image}`;
                    } else if (att.filePath) {
                        url = `${path}/${att.filePath.replace(/^\/+/, '')}`;
                    }

                    return { ...att, url };
                });

                setExistingAttachments(fallback);
                setServerAttachmentIds(fallback.filter(a => a.id).map(a => a.id));

            } catch (err) {
                console.error('fetchAttachments error:', err);
            }
        };

        fetchAttachments();
    }, [taskData, path, companyId]);

    // Function to open the image viewer dialog
    const openImageViewer = (src, title) => {
        setImageViewer({ open: true, src: src, title: title || 'Attachment', });
    };

    // Dialog to display the image in full size
    const ImageViewerDialog = () => (
        <Dialog open={imageViewer.open} onClose={() => setImageViewer((v) => ({ ...v, open: false }))} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>{imageViewer.title}</span>
                <IconButton onClick={() => setImageViewer((v) => ({ ...v, open: false }))} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {imageViewer.src && (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={imageViewer.src} alt={imageViewer.title || 'Attachment'} style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );

    const handleAssignChange = (selected) => {
        setAssignedToId(String(selected.UserId));
        setAssignedToName(selected.employeeName);
    };

    // Read selected files as base64 for previews (FormData logic unchanged)
    const handleFileChange = (e) => {
        const fileList = Array.from(e.target.files || []);
        setFiles(fileList);
        setFilePreviews([]); // reset previews

        fileList.forEach((file) => {
            const isImg = file.type && file.type.toLowerCase().startsWith('image/');

            if (!isImg) {
                // non-image: no need base64, just show as chip
                setFilePreviews((prev) => [...prev, { file, url: '', isImage: false, },]);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                // reader.result is base64 data URL
                setFilePreviews((prev) => [...prev, { file, url: reader.result, isImage: true, },]);
            };
            reader.readAsDataURL(file);
        });
    };

    // Function for form submission
    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            const errors = [];

            if (!title.trim()) errors.push('Title is mandatory.');
            if (!assignedToId) errors.push('Assigned To is mandatory.');
            if (!dueDateTime) errors.push('Due date & time is mandatory.');

            const due = new Date(dueDateTime);
            if (isNaN(due.getTime())) {
                errors.push('Invalid due date & time.');
            }

            if (errors.length > 0) {
                setFormErrors(errors);
                return;
            }

            setIsSubmitting(true);
            setFormErrors([]);

            try {
                const formData = new FormData();
                formData.append('taskTitle', title);
                formData.append('description', description);
                formData.append('assignedToId', assignedToId);
                formData.append('assignedToName', assignedToName);
                formData.append('assignedById', String(uId));
                formData.append('assignedByName', userName);
                formData.append('companyId', companyId);
                formData.append('dueDateTime', dueDateTime);
                formData.append('priority', priority);
                formData.append('status', status);
                formData.append('reminderMinutesBefore', reminderMinutesBefore);

                // ⬇️ Send binary files (new uploads) through FormData
                files.forEach((f) => { formData.append('files', f); });

                // ⬇️ SOLUTION: In edit mode, also send existing attachment IDs that should be kept
                if (overallMode === 'edit') {
                    // IDs currently visible in UI (user kept)
                    const currentIds = existingAttachments.filter(a => a.id && !a.isNew).map(a => a.id);

                    // IDs originally on server but now missing (user removed)
                    const deletedAttachmentIds = serverAttachmentIds.filter(id => !currentIds.includes(id));

                    // Send existing attachment IDs that should be kept
                    formData.append('existingAttachmentIds', JSON.stringify(currentIds));

                    // Send deleted attachment IDs
                    formData.append('deleteAttachmentIds', JSON.stringify(deletedAttachmentIds));
                }

                const debugPayload = { mode: overallMode, taskId: overallMode === 'edit' ? taskData?.TaskId : null, taskTitle: title, description, assignedToId, assignedToName, assignedById: String(uId), assignedByName: userName, companyId, dueDateTime, priority, status, reminderMinutesBefore, newFiles: files.map((f) => f.name), existingAttachmentIds: overallMode === 'edit' ? existingAttachments.filter(a => a.id && !a.isNew).map(a => a.id) : [], };
                console.log('TaskForm submit mode:', overallMode);
                console.log('TaskForm submit payload:', debugPayload);
                let res;

                if (overallMode === 'edit' && taskData?.TaskId) {
                    formData.append('taskId', taskData.TaskId);
                    res = await axios.put(`${path}/api/tasks/${taskData.TaskId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
                } else {
                    res = await axios.post(`${path}/api/tasks`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
                }

                if (res.status === 200 || res.status === 201) {
                    setSnackbar({ open: true, message: overallMode === 'edit' ? 'Task updated successfully!' : 'Task created successfully!', severity: 'success', });
                    setTimeout(() => { navigate(-1) }, 600)
                } else {
                    setSnackbar({ open: true, message: res.data?.message || 'Task save failed.', severity: 'error', });
                }
            } catch (err) {
                console.error('Error saving task:', err);
                setSnackbar({ open: true, message: 'Something went wrong while saving the task.', severity: 'error', });
            } finally {
                setIsSubmitting(false);
            }
        },
        [assignedToId, assignedToName, companyId, dueDateTime, overallMode, path, priority, reminderMinutesBefore, status, taskData, title, description, files, uId, userName, navigate, existingAttachments, serverAttachmentIds]
    );

    const handleCancel = () => navigate(-1);

    return (
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
            <Paper sx={{ p: 3, maxWidth: 900, width: '100%' }}>
                <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', mb: 3, textDecoration: 'underline', textUnderlineOffset: 8 }} >
                    {overallMode === 'edit' ? 'Edit Task' : 'Create New Task'}
                </Typography>

                <Box display="flex" flexWrap="wrap" gap={2}>
                    {/* LEFT COLUMN – title, description, attachments */}
                    <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }} >
                        <TextField label="Task Title" value={title} size='small' onChange={(e) => setTitle(e.target.value)} fullWidth required InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} />
                        <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline minRows={2.7} />

                        {/* Attachments under description */}
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Attachments (images, videos, audio, documents, etc.)
                            </Typography>
                            <input type="file" multiple onChange={handleFileChange} />

                            {/* New uploads (base64 previews) */}
                            {filePreviews.length > 0 && (
                                <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap">
                                    {filePreviews.map((p, index) =>
                                        p.isImage ? (
                                            <Box key={index} onClick={() => openImageViewer(p.url, p.file.name)}
                                                sx={{ width: 80, height: 80, borderRadius: 1, overflow: 'hidden', border: `1px solid ${themeColors.neutral.lineStrong}`, mr: 1, mb: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: themeColors.neutral.surfaceAlt, }}
                                            >
                                                <img src={p.url} alt={p.file.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </Box>
                                        ) : (
                                            <Chip key={index} icon={<AttachmentIcon />} label={p.file.name} sx={{ mb: 1 }} variant="outlined" />
                                        )
                                    )}
                                </Stack>
                            )}

                            {/* Existing attachments (edit mode) */}
                            {existingAttachments.length > 0 && (
                                <>
                                    <Typography variant="subtitle2" sx={{ mt: 2 }}>
                                        Existing Attachments:
                                    </Typography>
                                    <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap">
                                        {existingAttachments.map((att, idx) => {
                                            const isImg = isImageAttachment(att);
                                            const src = att.url;
                                            const label = att.fileName || att.name || `Attachment ${idx + 1}`;

                                            if (isImg && src) {
                                                return (
                                                    <Box key={idx} sx={{ position: 'relative', width: 80, height: 80, borderRadius: 1, overflow: 'hidden', border: `1px solid ${themeColors.neutral.lineStrong}`, mr: 1, mb: 1, cursor: 'pointer', backgroundColor: themeColors.neutral.surfaceAlt, }} >
                                                        <img src={src} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onClick={() => openImageViewer(src, label)} />

                                                        {/* ❌ REMOVE BUTTON */}
                                                        <IconButton size="small" sx={{ position: 'absolute', top: 2, right: 2, bgcolor: 'rgba(0,0,0,0.6)', color: themeColors.neutral.surface, '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' }, }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setExistingAttachments(prev => prev.filter((_, i) => i !== idx));
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                );
                                            }

                                            return (
                                                <Chip key={idx} icon={<AttachmentIcon />} label={label} variant="outlined" onDelete={() => setExistingAttachments(prev => prev.filter((_, i) => i !== idx))}
                                                    onClick={() => {
                                                        if (att.url) {
                                                            window.open(att.url, '_blank', 'noopener,noreferrer');
                                                        }
                                                    }}
                                                />

                                            );
                                        })}
                                    </Stack>
                                </>
                            )}
                        </Box>
                    </Box>

                    {/* RIGHT COLUMN – assign / due / priority / status / reminder */}
                    <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }} >
                        <Dropdown id="assignTo" label="Assign To" valueKey="UserId" labelKey="employeeName" value={assignedToId} options={usersOptions} onChange={handleAssignChange} fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} />


                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DesktopDateTimePicker label="Due Date & Time" value={dueDateTime ? dayjs(dueDateTime) : null}
                                onChange={(newValue) => {
                                    if (newValue && newValue.isValid()) {
                                        setDueDateTime(newValue.format('YYYY-MM-DDTHH:mm'));
                                    } else {
                                        setDueDateTime('');
                                    }
                                }}
                                viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                }}
                                ampm={false}
                                format="DD MMMM YYYY • HH:mm"
                                timeSteps={{ hours: 1, minutes: 5, seconds: 1 }}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: true,
                                        size: 'small',
                                        variant: "outlined",
                                        InputLabelProps: {
                                            sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: themeColors.error.dark, // 🔴 red star
                                                },
                                            },
                                        },
                                        sx: {
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                fontWeight: 500,
                                                height: 38,
                                                backgroundColor: 'background.paper',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                },
                                                '&.Mui-focused': {
                                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: 'primary.main',
                                                fontWeight: 600,
                                            },
                                        },
                                    },
                                    popper: {
                                        sx: {
                                            '& .MuiPickersPopper-paper': {
                                                borderRadius: 4,
                                                boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
                                                overflow: 'hidden',
                                                mt: 1,
                                            },
                                            '& .MuiPickersLayout-root': {
                                                borderRadius: 4,
                                            },
                                            '& .MuiPickersDay-root': {
                                                borderRadius: '12px',
                                                fontWeight: 500,
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                },
                                            },
                                            '& .MuiPickersDay-today': {
                                                border: '2px solid',
                                                borderColor: 'primary.main',
                                                backgroundColor: 'transparent',
                                                fontWeight: 700,
                                            },
                                            '& .MuiPickersDay-selected': {
                                                backgroundColor: 'primary.main',
                                                color: 'primary.contrastText',
                                                fontWeight: 600,
                                                '&:hover': {
                                                    backgroundColor: 'primary.dark',
                                                },
                                            },
                                            '& .MuiClock-clock': {
                                                backgroundColor: 'grey.50',
                                                boxShadow: 'inset 0 4px 12px rgba(0,0,0,0.05)',
                                            },
                                            '& .MuiClock-pin': {
                                                backgroundColor: 'primary.main',
                                                width: 4,
                                            },
                                            '& .MuiClockPointer-pointer': {
                                                backgroundColor: 'primary.main',
                                            },
                                            '& .MuiClockPointer-thumb': {
                                                border: '6px solid',
                                                borderColor: 'primary.main',
                                                backgroundColor: 'common.white',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                            },
                                            '& .MuiClockNumber-root.Mui-selected': {
                                                backgroundColor: 'primary.main',
                                                color: 'primary.contrastText',
                                                fontWeight: 600,
                                            },
                                        },
                                    },
                                    actionBar: {
                                        actions: ['clear', 'cancel', 'accept'],
                                    },
                                }}
                            />
                        </LocalizationProvider>

                        <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}>
                            <InputLabel id="priority-label">Priority</InputLabel>
                            <Select labelId="priority-label" label="Priority" value={priority} onChange={(e) => setPriority(e.target.value)} >
                                <MenuItem value="Low">Low</MenuItem>
                                <MenuItem value="Medium">Medium</MenuItem>
                                <MenuItem value="High">High</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}>
                            <InputLabel id="status-label">Status</InputLabel>
                            <Select labelId="status-label" label="Status" value={status} onChange={(e) => setStatus(e.target.value)}  >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                                <MenuItem value="Cancelled">Cancelled</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField label="Reminder (minutes before)" type="number" value={reminderMinutesBefore} onChange={(e) => setReminderMinutesBefore(Number(e.target.value) || 0)} fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }} helperText="Default is 60 (1 hour before)" />
                    </Box>
                </Box>

                {/* Errors */}
                {formErrors.length > 0 && (
                    <Box sx={{ mx: 'auto', maxWidth: 400, p: 2, bgcolor: '#ffebee', border: 1, borderColor: themeColors.error.main, borderRadius: 1, color: themeColors.error.darker, mt: 3, }} >
                        <Typography fontWeight="bold">Please fix:</Typography>
                        <ul>
                            {formErrors.map((e, i) => (
                                <li key={i}>{e}</li>
                            ))}
                        </ul>
                    </Box>
                )}

                {/* Action buttons */}
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 3, justifyContent: 'center', }} >
                    <MuiButton onClick={handleSubmit} variant="contained" color="primary" sx={{ minWidth: 120, height: 40 }} disabled={isSubmitting} >
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </MuiButton>
                    <MuiButton onClick={handleCancel} variant="contained" color="error" sx={{ minWidth: 120, height: 40 }} disabled={isSubmitting} >
                        Cancel
                    </MuiButton>
                </Box>
            </Paper>

            {/* Image Viewer Dialog → always show base64 or URL */}
            <ImageViewerDialog />

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} >
                <Alert onClose={() => setSnackbar((s) => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default TaskForm;